// @TODO: figure out how to get rid of this ts-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useViewTransition } from 'use-view-transitions/react'

export const useStartViewTransition = () => useViewTransition().startViewTransition
